import { AppState } from '../index';
import { JournalEntry } from '../../models/journal-entry';
import { createSelector } from '@ngrx/store';
import { Clock } from '../../utils/clock';
import { ActionStatusEnum } from '../../enum/action-status.enum';
import { Action } from '../../models/action';
import { ActionEnum } from '../../enum/action.enum';
import { shipmentActions } from '../../constants/shipment-actions';

const RECENT_SECONDS = 60 * 5;

export interface JournalState {
    entries: Action[];
}

export const selectJournalState = (state: AppState) => state.journal;

export const selectJournalEntries = createSelector(selectJournalState,
    (state: JournalState) => state.entries);

export const selectJournalBusy = createSelector(selectJournalState,
    (state: JournalState) => state.entries
        .filter((e) => Clock.ageInSeconds(e.updatedAt) < RECENT_SECONDS)
        .filter((e) => e.status === ActionStatusEnum.PROCESSING || e.status === ActionStatusEnum.PENDING)
        .length > 0
);

export const selectJournalActive = createSelector(selectJournalState,
    (state: JournalState) => state.entries
    .filter((e) => e.status === ActionStatusEnum.PENDING || e.status === ActionStatusEnum.PROCESSING)
    .filter((e) => Clock.ageInSeconds(e.updatedAt) < RECENT_SECONDS)
);

export const selectJournalRecent = createSelector(selectJournalState,
    (state: JournalState) => state.entries
        .filter((e) => Clock.ageInSeconds(e.updatedAt) < RECENT_SECONDS)
        .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
);

export const selectJournalBusyShipments = createSelector(selectJournalState,
    (state: JournalState) => [].concat.apply([], state.entries
        .filter((e) => shipmentActions.indexOf(e.actionId) !== -1)
        .filter((e) => e.status === ActionStatusEnum.PENDING || e.status === ActionStatusEnum.PROCESSING)
        .filter((e) => !!e.entityIds)
        .map((e) => e.entityIds)
    )
);

export const activeShipmentActions = (shipmentId: string) => createSelector(selectJournalActive,
    (actions) => actions
        .filter((e) => shipmentActions.indexOf(e.actionId) !== -1)
        .filter((e) => e.entityIds.indexOf(shipmentId) !== -1)
);
